<template>
  <div id="list" >
    <van-search placeholder="搜索赛事" show-action shape="round">
      <div slot="action" >搜索</div>
    </van-search>
    <div class="title" >
      <ul>
        <li>用户编号</li>
        <li>姓名</li>
        <li>性别</li>
      </ul>
    </div>
    <div class="main" >
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <van-cell v-for="item in list" :key="item" :title="item"></van-cell>
      </van-list>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import { List, Search } from 'vant'
Vue.use(List).use(Search)
export default {
  name: 'TeamList',
  data() {
    return {
      list: [],
      loading: false,
      finished: false
    }
  },
  mounted() {},
  methods: {
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        for (let i = 0; i < 10; i++) {
          this.list.push(this.list.length + 1)
        }
        // 加载状态结束
        this.loading = false

        // 数据全部加载完成
        if (this.list.length >= 40) {
          this.finished = true
        }
      }, 500)
    }
  },
  computed: {}
}
</script>
<style>
  #list {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: white;
  }

  #list .name {
    font-size: 22px;
    text-align: center;
    font-weight: bolder;
    padding: 15px 0;
  }

  #list .title {
    padding: 15px 0;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
  }

  #list .title ul {
    display: flex;
  }

  #list .title ul li {
    flex: 1;
    text-align: center;
    font-size: 16px;
    border-right: 1px solid #ccc;
  }

  #list .title ul li:last-child {
    border-right: none;
  }

  #list .main {
    position: absolute;
    width: 100%;
    height: calc(100% - 100px);
  }

  #list .href {
    text-align: right;
    padding: 0 0 10px 0;
  }

</style>



// WEBPACK FOOTER //
// src/pages/ucenter/match-enroll.vue